// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"03769016","513":"672531b7","703":"6f4e8971","787":"e03fdec2"}[chunkId] + ".chunk.js";
};